module.exports = __webpack_public_path__ + "static/media/inspections.395c1218.svg";